import { GetOfficesCountByStateClient } from '../clients/GetOfficesCountByState';
import { IGetOfficesCountByStateParams } from '../types/IGetOfficesCountByStateParams';
import { IOfficesCountByStateResponse } from '../types/IOfficesCountByStateResponse';

export const OfficesService = {
  getOfficesCountByState: (
    params: IGetOfficesCountByStateParams,
  ): Promise<IOfficesCountByStateResponse> =>
    GetOfficesCountByStateClient.getOfficesCountByState(params),
};
